import { render, staticRenderFns } from "./BasketballFilters.vue?vue&type=template&id=ef993112&"
import script from "./BasketballFilters.vue?vue&type=script&lang=js&"
export * from "./BasketballFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports